export default "__VITE_ASSET__CBLUF8Dr__"